import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
const handleStatus = (result) => {
    if ((result === null || result === void 0 ? void 0 : result.statusCode) === StatusCodes.UNAUTHORIZED) {
        throw new UnauthorizedError();
    }
    if ((result === null || result === void 0 ? void 0 : result.statusCode) === StatusCodes.OK) {
        return result;
    }
    return null;
};
/**
 * Acl admin API — wraps /json/users_roles, /json/users_rights, /json/role_rights
 * and /json/groups_roles. All routes are gated on the backend by
 * RightUsers.users_roles_read (list) or users_roles_write (save).
 */
export class Acl {
    static async getRoles() {
        var _a;
        const result = handleStatus(await NetFetch.postData('/json/users_roles/list', {}));
        return (_a = result === null || result === void 0 ? void 0 : result.list) !== null && _a !== void 0 ? _a : [];
    }
    static async saveRoleName(id, name) {
        const result = handleStatus(await NetFetch.postData('/json/users_roles/save', { id, name }));
        return result !== null;
    }
    static async deleteRole(id) {
        const result = handleStatus(await NetFetch.postData('/json/users_roles/delete', { id, name: '' }));
        return result !== null;
    }
    static async getRights() {
        var _a;
        const result = handleStatus(await NetFetch.postData('/json/users_rights/list', {}));
        return (_a = result === null || result === void 0 ? void 0 : result.list) !== null && _a !== void 0 ? _a : [];
    }
    static async getRoleRights(roleId) {
        var _a;
        const result = handleStatus(await NetFetch.postData('/json/role_rights/list', { role_id: roleId }));
        return (_a = result === null || result === void 0 ? void 0 : result.list) !== null && _a !== void 0 ? _a : [];
    }
    static async saveRoleRights(roleId, list) {
        const result = handleStatus(await NetFetch.postData('/json/role_rights/save', { role_id: roleId, list }));
        return result !== null;
    }
    static async getGroupsRoles() {
        var _a;
        const result = handleStatus(await NetFetch.postData('/json/groups_roles/list', {}));
        return (_a = result === null || result === void 0 ? void 0 : result.list) !== null && _a !== void 0 ? _a : [];
    }
    static async saveGroupRoles(groupId, roleIds) {
        const result = handleStatus(await NetFetch.postData('/json/groups_roles/save', { group_id: groupId, role_ids: roleIds }));
        return result !== null;
    }
}
